import { useEffect, useRef, useState } from "react";
// import { useStore } from "store";
import socketIo from "util/socket";
import useAuth from "hooks/useAuth";

export default function useSocketIo(url) {
  const [socket, setSocket] = useState(null);
  // const {store} = useStore();
  const { token } = useAuth();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      // const query = `token=4{store}`
      const ssocket = socketIo(token, { ...(url && { url }) });
      if (ssocket) {
        setSocket(ssocket);
        initialized.current = true;
        ssocket.on("connect", () => {
          console.log("connected to socketIo");
        });

        ssocket.on("disconnect", () => {
          console.log("disconnected from socketIo");
        });
      }
    }

    if (!token) cleanup();
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    function handleFocus() {
      socket && socket?.disconnect && socket?.emit("triggerdisconnect", {});
      console.log("socketIo reconnected");
    }
    function handleBlur() {
      //  socket && socket?.disconnect && socket?.emit("triggerdisconnect", {});
    }

    function cleanup() {
      socket && socket?.disconnect && socket?.emit("triggerdisconnect", {});
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
    }
    return cleanup;
  }, [socket, token, url]);

  return socket;
}
